import mission from "../../../Assets/Img/mission.png"
import vision from "../../../Assets/Img/vision.png"
import mantra from "../../../Assets/Img/mantra.png"
import ourmission from "../../../Assets/Img/ourmission.webp"
import ourvision from "../../../Assets/Img/ourvision.webp"
import ourmantra from "../../../Assets/Img/ourmantra.webp"
import ourteaam from "../../../Assets/Img/ourteaam.webp"

const ValueData = [
    {
        Img: ourmission,   
        Imgicon: mission,
        heading: "Our Mission",
        text:"SmartB, we are committed to first understanding your business needs",
        descrption:"Once your requirements are clear and we've agreed on the deliverable, we make it happen. We have delivered our promises in the past and we will continue to deliver the same promise in the future."
    },
    {
        Img:ourvision,
        Imgicon: vision,
        heading: "Our Mission ",
        text:"SmartB, we are committed to first understanding your business needs",
        descrption:"Once your requirements are clear and we've agreed on the deliverable, we make it happen. We have delivered our promises in the past and we will continue to deliver the same promise in the future."
   
    },
    {
        Img: ourmantra,
        Imgicon: mantra,
        heading: "Our Mantra",
        text:"SmartB, we are committed to first understanding your business needs",
        descrption:"Once your requirements are clear and we've agreed on the deliverable, we make it happen. We have delivered our promises in the past and we will continue to deliver the same promise in the future."
   
    },

{
    Img: ourteaam,
    Imgicon: mantra,
    heading: "Our Mantra",
    text:"SmartB, we are committed to first understanding your business needs",
    descrption:"Once your requirements are clear and we've agreed on the deliverable, we make it happen. We have delivered our promises in the past and we will continue to deliver the same promise in the future."

}

]
export default ValueData;